module.exports = global["rop"] = require("-!./index.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/expose-loader?rop!./~/messager/index.js
 ** module id = 191
 ** module chunks = 1
 **/